export default "__VITE_ASSET__u7NauFUn__"